import {serializr} from '@mecatran/serializr-extensions';


// console.log('serializr',serializr)

export class DataDeserializer{
    constructor(dataDeserializerOptions){
        var _schema; 

        Object.defineProperty(this,'schema',{
            set : function(s){ _schema = s },
            get : function(){ return _schema }
        })

        this.initDataDeserializer(dataDeserializerOptions);

    }

    // ===========
    // private 
    // -----------

    setSchema(s){ this.schema = s }

    getSchema(){ return this.schema }

    initDataDeserializer(dataDeserializerOptions){
        this.setSchema(dataDeserializerOptions.schema);
    }

    // ==========
    // public 
    // ----------
    deserialize(data){
        var schema = this.getSchema();
        if (!schema) return data;
        var promise = new Promise((resolve,reject)=>{
            var callback = (e,d)=>{ 
                /*
                 if (e) reject(e);
                 //if (e) console.log(e);
                 resolve(d);
                 */
                 if (e) return;
            }
            var res = serializr.deserialize(schema, data, callback );
            resolve(res)
        });
        return promise;
    }
    
}



export class DataDeserializerOptions{
    constructor(options){
        var _schema = (options && options.schema) ? options.schema : undefined;

        Object.defineProperty(this,'schema',{
            set : function(s){ _schema =s },
            get : function(){ return _schema }
        })
    }

    // ==========
    // public 
    // ----------

}